// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"15deb70d49548c2638ff","678":"3b70151e43bbb33e9eff","883":"7429dc5110fadb131243"}[chunkId] + ".js";
};